import React, { useState } from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  IconButton,
  Typography,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import PropTypes from "prop-types"
import avatar1 from "../../assets/images/avatar/avatar1.png"
import { Auth } from "aws-amplify"
import i18n from "i18n"

const ModalImage = ({ openImage, setOpenImage, user }) => {
  const [image, setImage] = useState(user["custom:avatar"])

  const onClose = () => {
    setOpenImage(false)
  }

  const handleonClick = e => {
    let varImage = e.currentTarget.src

    if (varImage.charAt(0) == "o") {
      setImage(varImage.slice(1))
    } else {
      setImage(e.currentTarget.src)
    }
  }

  async function saveImage() {
    try {
      let user = await Auth.currentAuthenticatedUser()
      let result = await Auth.updateUserAttributes(user, {
        "custom:avatar": image,
      })
      // SUCCESS
      location.reload()
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Dialog open={openImage} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
        }}
      >
        <Typography sx={{ fontWeight: "bold", fontSize: "1.1rem" }}>
          {i18n.t("profile.changeAvatar")}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: 1,
          }}
        >
          <Box sx={{ mb: 2 }}>
            <img
              src={image}
              alt={avatar1}
              style={{
                width: 120,
                height: 120,
                borderRadius: "50%",
                objectFit: "cover",
                border: "2px solid #E4E4E4",
              }}
            />
          </Box>
          <Typography variant="body" align="center" sx={{ mb: 2 }}>
            {i18n.t("profile.changeAvatarCTA")}
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              justifyContent: "center",
              mb: 3,
              maxWidth: 300,
            }}
          >
            {[1, 2, 3, 4, 5, 6].map(num => (
              <Box
                key={num}
                sx={{
                  cursor: "pointer",
                  borderRadius: "50%",
                  border:
                    image ===
                    `https://assets.planhopper.com/avatares/avatar${num}.png`
                      ? "2px solid #1976d2"
                      : "2px solid transparent",
                  p: 0.5,
                }}
              >
                <img
                  src={`https://assets.planhopper.com/avatares/avatar${num}.png`}
                  alt={`avatar${num}`}
                  style={{
                    width: 60,
                    height: 60,
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                  onClick={handleonClick}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <Button
          variant="contained"
          color="branded"
          size="large"
          onClick={saveImage}
        >
          {i18n.t("Guardar")}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ModalImage.propTypes = {
  openImage: PropTypes.bool.isRequired,
  setOpenImage: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}
export default ModalImage
